import { ref, watch, computed } from 'vue';
import { useProductPrice } from '~/modules/price/composables/useProductPrice';
import useProductImagesCtaStore from '~/stores/useProductImagesCtaStore';
import useProductImagesCtaActions from './useProductImagesCtaActions';

export default function useValuePriceCta() {
  const { addCtaItem, removeCtaItem, updateCtaItem } = useProductImagesCtaActions();
  const productImagesCtaStore = useProductImagesCtaStore();
  const isAdded = ref(false);
  const ctaId = 'valuePrice';

  const otherCtasExist = computed(() => {
    return productImagesCtaStore.itemsList.some((item) => item.id !== ctaId);
  });

  function addCta(label) {
    if (!label) return;

    const itemData = {
      id: ctaId,
      label,
      customCssClass: 'value-price-cta',
      showArrow: false,
      onClickHandler: () => {},
      customStyle: { textTransform: 'none' },
    };

    if (isAdded.value) {
      updateCtaItem(ctaId, itemData);
    } else {
      addCtaItem(itemData);
      isAdded.value = true;
    }
  }

  function removeCta() {
    if (!isAdded.value) return;
    removeCtaItem(ctaId);
    isAdded.value = false;
  }

  async function init() {
    try {
      const selectedPrice = useProductPrice();
      watch(
        () => [
          selectedPrice.value?.priceType?.giftPriceLabelToAllUpcs,
          selectedPrice.value?.lowestSalePriceTier || selectedPrice.value?.regularPriceTier,
          otherCtasExist.value,
        ],
        ([giftPriceLabel, priceTier, otherExists]) => {
          if (!giftPriceLabel || otherExists) {
            removeCta();
            return;
          }
          const priceValue = priceTier?.values?.[0]?.formattedValue;
          const labelParts = [];

          if (priceValue) {
            const formattedPrice = String(priceValue).replace(/\.(\d+)$/, (_, dec) =>
              dec === '00' ? '' : `<sup style="vertical-align: top;">${dec}</sup>`,
            );

            labelParts.push("<span class='value-price' style='margin-bottom: 4px'>ONLY</span>");
            labelParts.push(`<span class='price large'>${formattedPrice}</span>`);
          }

          const formattedGiftPriceLabel = giftPriceLabel?.replace(/\.\d+/g, '');

          if (formattedGiftPriceLabel) {
            labelParts.push(`<span class='value-price'>${formattedGiftPriceLabel}</span>`);
          }

          const label = labelParts.join('<br>');

          addCta(label);
        },
        { immediate: true },
      );
    } catch (e) {
      console.error(e, 'Failed while adding value price cta');
    }
  }

  return {
    init,
    isAdded,
  };
}
